import React from "react";
import styled from "styled-components";

const Container = styled.div`
  flex: 1;
  padding: 5px 15px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 5px 16px;
  line-height: 1.2;
  background-color: ${props => props.theme.mainLight};
  border-radius: 4px;
`;

const Heading = styled.div`
  width: 100%;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: ${props => props.theme.accent};
`;

const Content = styled.div`
  width: 100%;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "10px"};
  color: ${({ theme }) => theme.foreground};
`;

export default function AdsContainer() {
  return (
    <Container>
      <Wrapper>
        <Heading>
          Блок для уведомлений, акций, рекламы
        </Heading>
        <Content>
          adipiscing elit, sed do eiusmod tempor
        </Content>
      </Wrapper>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/TradeMobile/AdsBlock.js